<span>
  <button appRequirePermission="admin.all,payment.processing"
          class="btn btn-primary btn-sm"
          *ngIf="showProcessOutgoingButton()"
          (click)="processPayment()">
          <bi name="plus-circle"></bi>
            Process
  </button>
</span>
